// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---Zs7kB","changedRecordsList":"changedRecordsList---myrm0","changedRecord":"changedRecord---FsFCL"};